import type { ColumnDef } from "@tanstack/react-table";
import type { GovernanceRow } from "../types/Governance";

const titleize = (s: string | null) =>
  s ? s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "";

export const governanceColumns: ColumnDef<GovernanceRow>[] = [
  {
    accessorKey: "name",
    header: "Description",
    cell: ({ row }) => row.original.name,
  },
  {
    accessorKey: "resourceName",
    header: "Resource",
    cell: ({ row }) => row.original.resourceName,
  },
  {
    id: "phaseOrAllocation",
    header: "Phase",
    cell: ({ row }) =>
      row.original.phaseName ?? titleize(row.original.allocationMethod),
  },
  {
    id: "amount",
    header: "Amount",
    cell: ({ row }) => {
      const { calculationType, fixedHours, rate } = row.original;
      if (calculationType === "percent_of_total" && rate != null) {
        return `${(rate * 100).toFixed(2)}% of total LOE`;
      }
      if (calculationType === "fixed_hours" && fixedHours != null) {
        return `${fixedHours} LOE hours`;
      }
      return "—";
    },
  },
  {
    accessorKey: "required",
    header: "Required?",
    cell: ({ row }) => (row.original.required ? "Yes" : "No"),
  },
];
